import restUtils from "core/utils/rest";
import {
  InvestorMarker,
  InvestorMarkerAddPayload,
  investorMarkerTransformer,
  InvestorMarkerUpdatePayload,
  Marker,
  markerTransformer
} from "./transformers/marker";

export const getMarkers = (): Promise<Marker[]> => {
  const url = "hubwise-api/aml/markers";
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(markerTransformer);
  });
};

export const getMarkersOfInvestor = (investorId: string, markers: Marker[]): Promise<InvestorMarker[]> => {
  const url = `hubwise-api/aml/${investorId}/markers`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map((el: any) => investorMarkerTransformer(el, markers));
  });
};

export const updateInvestorMarker = (investorId: string, markerCode: string, payload: Partial<InvestorMarkerUpdatePayload>) => {
  const url = `hubwise-api/aml/${investorId}/markers/${markerCode}`;
  return restUtils.call("PortalApi", url, "PUT", payload);
};

export const addInvestorMarker = (investorId: string, payload: Partial<InvestorMarkerAddPayload>) => {
  const url = `hubwise-api/aml/${investorId}/markers`;
  return restUtils.call("PortalApi", url, "POST", payload);
};

export const removeInvestorMarker = (investorId: string, markerCode: string) => {
  const url = `hubwise-api/aml/${investorId}/markers/${markerCode}`;
  return restUtils.call("PortalApi", url, "DELETE");
};
